import { Schema as S } from "effect";

export const ApplyActionRequestSchema = S.Union(
  [S.Struct({
    crlogId: S.String,
    action: S.Literal("apply"),
  }),
  S.Struct({
    crlogId: S.String,
    action: S.Literal("cancel"),
  }),
  S.Struct({
    crlogId: S.String,
    matchPatientId: S.String,
    action: S.Literal("matching_select"),
  })],
);

export type ApplyActionRequest = S.Schema.Type<typeof ApplyActionRequestSchema>;
